import { useCallback, useEffect } from "react";

import { isModifierKeyPressed } from "@/utils/shortcuts";

const useKeyboardShortcut = (callback: () => void) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (isModifierKeyPressed(event) && event.key.toLowerCase() === "s") {
        event.preventDefault();
        callback();
      }
    },
    [callback],
  );

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    document.addEventListener("keydown", handleKeyDown as any);

    return () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      document.removeEventListener("keydown", handleKeyDown as any);
    };
  }, [handleKeyDown]);
};

export default useKeyboardShortcut;
